import Mock from 'mockjs'

const {page, save} = require('../util');
const {targetCollection} = require('./data');
const qs = require('qs');

Mock.mock('/target-collection/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(targetCollection, bodyObject);
    bodyObject.total = targetCollection.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/target-collection/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    save(bodyObject, targetCollection);
    return {
        code: 200,
        body: targetCollection,
    }
});
